module.exports = __webpack_public_path__ + "static/img/a-banner.cb990fc7.png";